import { getParsedExpectedServiceDays } from '@/util/helper/dataParser';
import { getParsedDateTime } from '@/util/helper/dateTime';
import { DATE_TIME_FORMAT_MAP } from '@/config/dateTime';
import { getPartTimeExpectedEndTime } from '../../helper/option';
export class CareOrderBabyFormForDetailConfirmationPage {
    #careOrderBabyForm;
    #maxServiceDays;
    constructor({ careOrderBabyForm, maxServiceDays, }) {
        this.#careOrderBabyForm = careOrderBabyForm;
        this.#maxServiceDays = maxServiceDays;
    }
    get parsedAllDayTimeSlot() {
        const allDayTimeSlot = this.#careOrderBabyForm.timeSlotList[0];
        if (!allDayTimeSlot)
            return '';
        const isAsap = this.#careOrderBabyForm.isAsap;
        const expectedStartTime = allDayTimeSlot.expectedStartTime;
        const expectedServiceDays = allDayTimeSlot.expectedServiceDays;
        const parsedExpectedStartTime = isAsap
            ? '越快越好'
            : getParsedDateTime({
                dateTime: expectedStartTime,
                format: DATE_TIME_FORMAT_MAP.DATE_TIME,
            }).parsedDateTime;
        const { parsedExpectedServiceDays } = getParsedExpectedServiceDays({
            expectedServiceDays,
            maxServiceDays: this.#maxServiceDays,
        });
        const parsedAllDayTimeSlot = `${parsedExpectedStartTime} ~ 服務 ${parsedExpectedServiceDays}`;
        return parsedAllDayTimeSlot;
    }
    get parsedPartTimeTimeSlotList() {
        const timeSlotList = this.#careOrderBabyForm.timeSlotList;
        const parsedTimeSlotList = timeSlotList.map((timeSlot) => {
            const expectedStartTime = timeSlot.expectedStartTime;
            const expectedServiceHours = timeSlot.expectedServiceHours;
            const expectedEndTime = getPartTimeExpectedEndTime({
                expectedStartTime,
                expectedServiceHours,
            });
            const { parsedDateTime: parsedExpectedStartTime } = getParsedDateTime({
                dateTime: expectedStartTime,
                format: DATE_TIME_FORMAT_MAP.DATE_TIME,
            });
            const { parsedDateTime: parsedExpectedEndTime } = getParsedDateTime({
                dateTime: expectedEndTime,
                format: DATE_TIME_FORMAT_MAP.DATE_TIME,
            });
            const parsedTimeSlot = `${parsedExpectedStartTime} ~ ${parsedExpectedEndTime}`;
            return parsedTimeSlot;
        });
        return parsedTimeSlotList;
    }
}
